import $ from "jquery";
import { readablePair } from "../../common/js/readableColor";

const customerServiceObject = {
  variables: {
    customerServiceSection: $(".customerService__inner"),
      url: window.location.href,
  },
  methods: {
    getCurrentComponent: function () {
      customerServiceObject.variables.customerServiceSection.each(function (
        index,
        element
      ) {
        const $element = $(element);
        // Authored colours, adjusted only where text would fail WCAG 1.4.3
        // contrast (e.g. white on brand blue #00adef): see readableColor.js
        const heading = readablePair($element.attr("data-headingcolor"), $element.attr("data-bg"));
        const body = readablePair($element.attr("data-color"), heading.background);
        $element
          .attr("id", `section_${index + 1}`)
          .css("background", body.background)
          .find(".title")
          .css("color", heading.text)
          .end()
          .find(".subtitle, .desc")
          .css("color", body.text);
      });

      $("#section_1")
        .find(".customerService__cta")
        .removeClass("chli_btn--outline")
        .addClass("chli_btn--white");
    },

    addHeight: function () {
      let maxHeight = 0;
      if ($(window).width() > 1200) {
        $(".customerService-section").each(function () {
          let height = $(this).outerHeight();
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
      } else {
        maxHeight = "auto";
      }

      // min-height (not height) keeps the sections equal but lets them grow when
      // text is enlarged (accessibility widget / WCAG 1.4.12 text spacing).
      $(".customerService-section").css("min-height", maxHeight);
    },

    callDataLayer : function(){
      $('.customerServiceCard__inner').on('click', function(e) {
        let section = e.currentTarget.closest('.customerServiceCard');
        let titleText = section.getElementsByClassName('subtitle')[0].innerText.trim();
        let obj = customerServiceObject.methods.dataLayerObj(e,titleText);
        createDataLayer("buttonClick",obj);
    });
    },

    init: function () {
      if ($(".customerService-section").length > 0) {
        this.getCurrentComponent();
        this.addHeight();
        this.callDataLayer();
      }
    },

    dataLayerObj : function(e,el) {
        var obj = {
            'articleName' : "",
            'blogCategory' : "",
            'blogPageCategory' : "",
            'buttonText' : e.currentTarget.innerText.replace(/\s+/g, ' ').trim(),
            'pageSection' : el ? el : "Customer Service Component",
            'planOption' : "",
            'productCategory' : "",
            'productName' : "",
            'question' : "",
            'searchTerm' : "",
            'videoTitle' : "",
            'bannerName' : "",
            'bannerType' : ""
        };
        return obj;
    }

  },
};

$(() => {
  customerServiceObject.methods.init();
});
